import apiClient from 'api/base';

export const getTaskAISuggestion = async (
  description: string,
  signal: AbortSignal,
): Promise<string> => {
  const response = await apiClient.post(
    '/paraphrase/task',
    {
      description,
    },
    {
      signal,
    },
  );

  return response?.data ?? '';
};

export const getRecognitionAISuggestion = async (
  description: string,
  signal: AbortSignal,
): Promise<string> => {
  const response = await apiClient.post(
    '/paraphrase/recognition',
    {
      description,
    },
    {
      signal,
    },
  );

  return response?.data ?? '';
};

export const getBroadcastAISuggestion = async (
  description: string,
  signal: AbortSignal,
): Promise<string> => {
  const response = await apiClient.post(
    '/paraphrase/broadcast',
    {
      description,
    },
    {
      signal,
    },
  );

  return response?.data ?? '';
};
